import React from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import Table from 'components/Table/Table';

function NCModal(props) {
  const { model, setOpen } = props;
  const { document } = props;

  return (
    <Modal title="Notas de crédito existentes" model={model} setOpen={setOpen} hideSave>
      {document?.creditNotes?.length > 0 && (
        <Table
          tableHead={['#', 'Documento', 'Estado', 'Cliente', 'Dirección', 'Total']}
          tableData={document.creditNotes.map((item, index) => {
            return [
              index + 1,
              item.NumAtCard,
              item.DocStatus === 'O' ? 'Abierto' : 'Cerrado',
              item.CardCode,
              item.Address2,
              item.DocTotal,
            ];
          })}
        />
      )}
    </Modal>
  );
}

export default NCModal;
